/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import MDTypography from "components/MDTypography";
import DataTable from "components/Tables/DataTable";

// Data
import Card from "@mui/material/Card";

// Dashboard components
import PageHeader from "components/pageHead/pageHead";
import { commonChips } from "constants/common/pageHeaderChips";
import { useEffect, useState } from "react";
import Layout from "components/LayoutContainers/mainLayout";
import { GeneralFetch } from "../../Api/generalFetch/generalFetch";
import LinearProgressComponent from "components/linearProgress/linearProgress";
import { nearMissData } from "layouts/tables/data/tableDataGenerator";
import CardsDash from "components/cardsDashBoard/cardsDashBoard";
import { getUsers } from "hooks/users/getUsers";
import { replace } from "utils/common/replaceIdsByValues";
import { RefetchData } from "schemas";
import { useRecoilValue } from "recoil";

function Dashboard() {
  const [selected, setSelected] = useState('nearmisses')
  const [tableData, setTableData] = useState([])
  const [cardsData, setCardsData] = useState([])
  const [loading, setLoading] = useState(false)
  const { fetchData } = GeneralFetch()
  const { users } = getUsers()
  const { rows, columns } = nearMissData({ data: tableData, object: selected })
  const refetchTable = useRecoilValue(RefetchData)

  useEffect(() => {
    setLoading(true)
    const fetchDataAsync = async () => {
      await fetchData({ dataBase: selected == 'boaspraticas' ? 'nearmisses' : selected }, `getDashBoardData?boapratica=${selected == 'boaspraticas' ? "true" : selected == "nearmisses" ? "false" : "N/A"}`, 'post', 'dashboard')
        .then((resp) => setCardsData(resp?.dashboard))
        .catch((e) => { })
      await fetchData({ dataBase: selected, dashboard: true }, `getTableData?boapratica=${selected == 'boaspraticas' ? "true" : selected == "nearmisses" ? "false" : "N/A"}`, 'post', 'tableData')
        .then((resp) => {
          replace(resp?.tableData, users)
          setTableData(resp?.tableData)
        })
        .catch((e) => { })

      setLoading(false)
    }

    if (users?.length > 0) {
      void fetchDataAsync();
    }
  }, [selected, users, refetchTable])

  return (
    <Layout>
      <MDBox py={0}>
        <PageHeader showAddBtn={true} selected={selected} setSelected={setSelected} chips={commonChips} />

        <CardsDash loading={loading} cardsData={cardsData} />

        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={0}
                  px={0}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  {loading && <LinearProgressComponent />}
                  <div style={{ margin: "20px 10px" }} >
                    <MDTypography variant="h6" color="white">
                      Meus registo mais recentes
                    </MDTypography>
                  </div>
                </MDBox>
                <MDBox pt={3}>
                  <DataTable
                    table={{ columns: columns?.filter(x => x.table == true), rows }}
                    noEndBorder
                    paginate={false}
                  />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </Layout>
  );
}

export default Dashboard;
